<template>
	<div v-if="showButtons" class="flex flex-wrap gap-8">
		<button class="button-green" @click="login">
			<slot>Log in</slot>
		</button>
		<button v-if="!$store.isExtension" class="button-yellow sm:max-md:hidden" @click="signup">
			Get started for free
		</button>
	</div>
</template>

<script>
import analytics from 'shared/utils/analytics'

export default {
	name: 'ButtonLogin',
	computed: {
		showButtons() {
			if (this.$auth.loading.value) return false
			if (this.$auth.isAuthenticated.value) return false
			// hide buttons on example session
			if (this.$route.fullPath.includes('/example')) return false
			return true
		},
	},
	methods: {
		async login() {
			analytics.track('Login Button Clicked')
			if (this.$store.isExtension) {
				await this.$auth.login()
			} else {
				await this.$auth.login({
					redirectAfterLogin: this.$route.fullPath,
				})
			}
		},
		signup() {
			analytics.track(`Get started For Free Button Clicked`)
			this.$auth.login({
				redirectAfterLogin: this.$route.fullPath,
			})
		},
	},
}
</script>
